import { Textarea } from "@chakra-ui/react";
import { useEffect, useState } from "react";

type AutoSaveTextAreaProps = {
  initialValue: string,
  onSave: (value: string) => Promise<void> | undefined;
  disabled: boolean;
  delay?: number;
  onSaveComplete?: () => void;
};

function AutoSaveTextArea({initialValue, onSave, disabled, delay = 2000, onSaveComplete}: AutoSaveTextAreaProps) {
  const [value, setValue] = useState<string>(initialValue);
  const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (newValue: string) => {
    setValue(newValue);
    
    // Clear the previous timeout if it exists
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    
    // Set a new timeout
    const newTimeout = setTimeout(() => {
      onSave(newValue);
      if (onSaveComplete) onSaveComplete();
    }, delay);
    
    setTypingTimeout(newTimeout);
  };

  // Cleanup timeout on component unmount
  useEffect(() => {
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  return (
    <Textarea size="sm" onChange={(e) => handleChange(e.target.value)} disabled={disabled} value={value} />
  );
}

export default AutoSaveTextArea;
